import Highcharts from "highcharts/highcharts";
import _ from "lodash/lodash";
import ViewController from "core/views/view.controller";
import {Colors} from "main/main.config";

function dataLabelsFormatter() {
    return this.y > 0 ? this.y : '';
}

export default class ChartBookingResourcesCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);
        this.chart = null;
        this.resourceCounts = {};

        // Bindings
        this.bookings = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    $onChanges(changes) {
        if (!changes.bookings) {
            return;
        }

        if (!changes.bookings.currentValue || !changes.bookings.currentValue.length) {
            this.bookings = [];
        }

        if (!this.chart) {
            this.createChart();
        }

        this.updateResourceCounts();
        this.updateChart();
    }

    updateChart() {
        let categories = [];
        let openCountData = [];
        let finishedCountData = [];

        _(this.resourceCounts).keys().sortBy(key => key.toLowerCase())
            .each(resourceName => {
                categories.push(resourceName);
                openCountData.push(this.resourceCounts[resourceName].open);
                finishedCountData.push(this.resourceCounts[resourceName].finished);
            });

        this.chart.xAxis[0].setCategories(categories);
        this.chart.series[0].setData(openCountData);
        this.chart.series[1].setData(finishedCountData);
        this.chart.setSize(null, null, false);
    }

    createChart() {
        this.chart = Highcharts.chart('chart-booking-resources-hs', {
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 10,
                spacingLeft: 0,
                spacingRight: 0,
            },

            title: {
                text: ''
            },

            tooltip: {
                enabled: false
            },

            xAxis: {
                type: 'category',
                categories: [],
                labels: {
                    rotation: -45,
                    style: {
                        color: Colors.highlight1,
                        fontSize: '14px',
                        fontWeight: '400',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                    }
                }
            },

            yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                    text: ''
                },

                stackLabels: {
                    enabled: true,
                    style: {
                        color: "#787878",
                        fontSize: "14px",
                        fontWeight: '600',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                    }
                }
            },

            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        formatter: dataLabelsFormatter,
                        style: {
                            color: 'white',
                            fontSize: "14px",
                            fontWeight: '600',
                            fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif',
                            textShadow: null,
                            textOutline: null
                        }
                    }
                },

                series: {
                    enableMouseTracking: false
                }
            },

            legend: {
                enabled: true,
                itemStyle: {
                    color: Colors.textNormal,
                    fontSize: "14px",
                    fontWeight: '400',
                    fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                }
            },

            series: [{
                name: 'Offen',
                data: [0],
                color: Colors.bg
            }, {
                name: 'Erledigt',
                data: [0],
                color: Colors.highlight1
            }]
        });
    }

    updateResourceCounts() {
        this.resourceCounts = {};

        _(this.bookings)
            .groupBy(booking => booking.resource.name)
            .each((bookings, resourceName) => {
                this.resourceCounts[resourceName] = {
                    open: 0,
                    finished: 0
                };

                bookings.forEach(booking=> {
                    if (booking.isOpen()) {
                        this.resourceCounts[resourceName].open++;
                    } else {
                        this.resourceCounts[resourceName].finished++;
                    }
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-resources/chart-booking-resources.controller.js